import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"label":_vm.displayText,"items":_vm.businessRolesList,"multiple":_vm.multiple,"chips":_vm.multiple,"item-text":"label","item-value":"name","readonly":_vm.readonly,"rules":[_vm.required(_vm.displayText)],"outlined":""},model:{value:(_vm.businessRolesValue),callback:function ($$v) {_vm.businessRolesValue=$$v},expression:"businessRolesValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }